import React, { Suspense } from "react";
import LoadingScreen from "../../components/loader/loading-screen";
import "./services.css";
import ProductCards from "./components/Products-tab";
import StepsToHire from "../../components/steps-to-hire";
import ContactForm from "../../components/forms/contact-form";
import ProductPartners from "../../components/product-partners";
import TestimonialCarousel from "../../components/carousels/testimonial-carousel";
import ServicesHero from "./components/hero";

const ServicesHome = () => {

    return (
        <Suspense fallback={<LoadingScreen />}>
            <section className="layout-wrapper">
                <ServicesHero />
                <ProductCards />
                <StepsToHire />
                <TestimonialCarousel />
                <ContactForm />
                <ProductPartners />
            </section>
        </Suspense>
    );
};

export default ServicesHome;
